import { render, staticRenderFns } from "./TransactionPreview.vue?vue&type=template&id=30c9d7ba&scoped=true"
import script from "./TransactionPreview.vue?vue&type=script&lang=js"
export * from "./TransactionPreview.vue?vue&type=script&lang=js"
import style0 from "./TransactionPreview.vue?vue&type=style&index=0&id=30c9d7ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c9d7ba",
  null
  
)

export default component.exports